module.exports = __webpack_public_path__ + "media/svg/ve-38c522da.svg";